import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { fetchEventUsers, deleteEventUser, fetchEventPayments, fetchEventAnalytics } from "./adminEventService";
import "./adminEventUsers.css";




const AdminEventUsersPage = () => {

 const { eventId } = useParams();
 const navigate = useNavigate();
 const location = useLocation();

 const eventTitle = location.state?.eventTitle || "Event";

 const [tab, setTab] = useState("users");
 const [users, setUsers] = useState([]);
 const [payments, setPayments] = useState([]);
 const [analytics, setAnalytics] = useState(null);
 const [loading, setLoading] = useState(true);


 const loadUsers = async () => {
 try {
 setLoading(true);
 const response = await fetchEventUsers(eventId);

 if (response.status === 200) setUsers(response.data);
 else alert(response.message || "Failed to load users");
 } catch (error) {

 } finally {
 setLoading(false);
 }
 };

 const loadPayments = async () => {
 try {
 setLoading(true);
 const response = await fetchEventPayments(eventId);

 if (response.status === 200) setPayments(response.data);
 else alert(response.message || "Failed to load payments");
 } catch (error) {

 } finally {
 setLoading(false);
 }
 };

 const loadAnalytics = async () => {
 try {
 setLoading(true);
 const response = await fetchEventAnalytics(eventId);

 if (response.status === 200) setAnalytics(response.data);
 else alert(response.message || "Failed to load analytics");
 } catch (error) {

 } finally {
 setLoading(false);
 }
 };

 const handleDeleteUser = async (bookingId, userName) => {
 if (!window.confirm(`Remove "${userName}" from this event?`)) return;
 try {
 const response = await deleteEventUser(eventId, bookingId);
 if (response.status === 200) loadUsers();
 else alert(response.message || "Failed to remove user");
 } catch (error) {

 }
 };

 const handleTabChange = (newTab) => {
 setTab(newTab);
 if (newTab === "users" && users.length === 0) loadUsers();
 if (newTab === "payments") loadPayments();
 if (newTab === "analytics") loadAnalytics();
 };

 useEffect(() => {
 loadUsers();
 }, [eventId]);

 const statusClass = (status) => {
 if (status === "SUCCESS") return "payment-status success";
 if (status === "FAILED") return "payment-status failed";
 return "payment-status pending";
 };

 return (
 <div className="users-page">

 <div className="users-header">
 <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
 <h2>{eventTitle}</h2>
 <div className="user-count">Bookings: {users.length}</div>
 </div>

 {/* Tabs */}
 <div className="event-tabs">
 <button className={`event-tab ${tab === "users" ? "active" : ""}`} onClick={() => handleTabChange("users")}>
 👥 Registered Users
 </button>
 <button className={`event-tab ${tab === "payments" ? "active" : ""}`} onClick={() => handleTabChange("payments")}>
 💳 Payments
 </button>
 <button className={`event-tab ${tab === "analytics" ? "active" : ""}`} onClick={() => handleTabChange("analytics")}>
 📊 Analytics
 </button>
 </div>

 {loading ? (
 <p className="loading-text">Loading...</p>
 ) : (
 <>
 {/* ── USERS TAB ── */}
 {tab === "users" && (
 <table className="users-table">
 <thead>
 <tr>
 <th>Name</th>
 <th>Email</th>
 <th>Mobile</th>
 <th>User ID</th>
 <th>Registered At</th>
 <th>Time Zone</th>
 <th>Actions</th>
 </tr>
 </thead>
 <tbody>
 {users.length === 0 ? (
 <tr><td colSpan="7" className="empty-cell">No users registered</td></tr>
 ) : (
 users.map((user, index) => (
 <tr key={user.bookingId || index}>
 <td>{user.name}</td>
 <td>{user.email}</td>
 <td>{user.mobile || "-"}</td>
 <td>{user.userId || "-"}</td>
 <td>{new Date(user.registeredAt).toLocaleString("en-IN")}</td>
 <td>{user.timeZone || "-"}</td>
 <td>
 <button
 className="delete-user-btn"
 onClick={() => handleDeleteUser(user.bookingId, user.name)}
 title="Remove user from event"
 >
 🗑️
 </button>
 </td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 )}

 {/* ── PAYMENTS TAB ── */}
 {tab === "payments" && (
 <table className="users-table">
 <thead>
 <tr>
 <th>#</th>
 <th>Name</th>
 <th>Email</th>
 <th>Mobile</th>
 <th>Amount</th>
 <th>Currency</th>
 <th>Razorpay Order ID</th>
 <th>Razorpay Payment ID</th>
 <th>Status</th>
 <th>Date</th>
 </tr>
 </thead>
 <tbody>
 {payments.length === 0 ? (
 <tr><td colSpan="10" className="empty-cell">No payments found</td></tr>
 ) : (
 payments.map((p, index) => (
 <tr key={p.paymentId || index}>
 <td>{p.paymentId}</td>
 <td>{p.name}</td>
 <td>{p.email}</td>
 <td>{p.mobile}</td>
 <td>₹{(p.amountInPaise / 100).toFixed(2)}</td>
 <td>{p.currency}</td>
 <td className="mono">{p.razorpayOrderId || "-"}</td>
 <td className="mono">{p.razorpayPaymentId || "-"}</td>
 <td><span className={statusClass(p.status)}>{p.status}</span></td>
 <td>{new Date(p.createdAt).toLocaleString("en-IN")}</td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 )}

 {/* ── ANALYTICS TAB ── */}
 {tab === "analytics" && (
 analytics ? (
 <div className="analytics-panel">
 <div className="analytics-grid">
 <div className="analytics-card-item">
 <div className="analytics-card-icon">🎫</div>
 <div className="analytics-card-value">{analytics.totalBookings}</div>
 <div className="analytics-card-label">Total Bookings</div>
 </div>
 <div className="analytics-card-item">
 <div className="analytics-card-icon">💺</div>
 <div className="analytics-card-value">{analytics.availableSeats}</div>
 <div className="analytics-card-label">Available Seats</div>
 </div>
 <div className="analytics-card-item">
 <div className="analytics-card-icon">💰</div>
 <div className="analytics-card-value">₹{Number(analytics.revenueGenerated).toLocaleString()}</div>
 <div className="analytics-card-label">Revenue (SUCCESS)</div>
 </div>
 </div>

 {analytics.demographics && (
 <div className="demographics-section">
 <h4>Demographics</h4>
 <p>📱 Mobile Users: <strong>{analytics.demographics.mobileUsers}</strong></p>
 {analytics.demographics.countries?.length > 0 && (
 <table className="users-table demographics-table">
 <thead>
 <tr><th>Country Code</th><th>Count</th></tr>
 </thead>
 <tbody>
 {analytics.demographics.countries.map((c, i) => (
 <tr key={i}>
 <td>{c.country}</td>
 <td>{c.count}</td>
 </tr>
 ))}
 </tbody>
 </table>
 )}
 </div>
 )}
 </div>
 ) : (
 <p className="empty-cell">No analytics data available.</p>
 )
 )}
 </>
 )}

 </div>
 );
};

export default AdminEventUsersPage;
